import { useDispatch, useSelector } from 'react-redux';
import { clearLandingPageData, updateListing } from '../store';

export const useUpdateBooking = () => {
  const listingPageData = useSelector((state) => state?.testDrive?.listingPage);
  const dispatch = useDispatch();

  const updateStateData = ({
    isBooked,
    ids,
    leadIds,
  }: {
    id?: number;
    leadId?: number;
    isBooked: boolean;
    ids?: number[];
    leadIds: number[];
  }) => {
    const newList = listingPageData?.list.map((item) => {
      const idx = ids.indexOf(item.data?.id);
      if (idx > -1) {
        return {
          ...item,
          data: {
            ...item.data,
            isBooked: isBooked,
            leadId: leadIds[idx],
          },
        };
      }
      return item;
    });
    if (isBooked) {
      dispatch(clearLandingPageData());
    }
    dispatch(updateListing({ ...listingPageData, list: newList }));
  };

  return {
    updateStateData,
  };
};
